import type { QueryClient } from "@tanstack/react-query";

import { WeightEntry } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";
import type { ISODate, Period } from "@/shared/models/legacy-types";

const DOMAIN = "progress-tracker";

interface GetWeightEntriesParams {
  periodType: Period;
  date: ISODate;
}

export const getWeightEntriesQuery = (params: GetWeightEntriesParams) => ({
  queryKey: [DOMAIN, "getWeightEntriesQuery", params],
  queryFn: async () => {
    const response = await privateAPI.get(`/weight-entries`, { params });

    return parseResponseData(response, WeightEntry.array());
  },
});

export const createWeightEntry = {
  mutation: async (params: Omit<WeightEntry, "id">) => {
    const response = await privateAPI.post(`/weight-entries`, params);

    return parseResponseData(response, WeightEntry);
  },
  invalidates: (queryClient: QueryClient) => {
    void queryClient.invalidateQueries({ queryKey: [DOMAIN] });
  },
};

export const editWeightEntry = {
  mutation: async (params: WeightEntry) => {
    const { id, ...rest } = params;
    const response = await privateAPI.put(`/weight-entries/${id}`, rest);

    return parseResponseData(response, WeightEntry);
  },
  invalidates: (queryClient: QueryClient) => {
    void queryClient.invalidateQueries({ queryKey: [DOMAIN] });
  },
};

export const deleteWeightEntry = {
  mutation: async (id: string) => {
    return await privateAPI.delete(`/weight-entries/${id}`);
  },
  invalidates: (queryClient: QueryClient) => {
    void queryClient.invalidateQueries({ queryKey: [DOMAIN] });
  },
};
